import { useEffect, useState } from "react";
import { LoginForm } from "./LoginForm";
import { meQuery } from "./api";

type AuthState =
  | { status: "checking" }
  | { status: "unauthenticated" }
  | { status: "authenticated" };

export function AuthGate({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<AuthState>({ status: "checking" });

  useEffect(() => {
    meQuery()
      .then((ok) => setState({ status: ok ? "authenticated" : "unauthenticated" }))
      .catch(() => setState({ status: "unauthenticated" }));
  }, []);

  if (state.status === "checking") {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-sm text-slate-500 dark:text-slate-400">
        Verificando sesión…
      </div>
    );
  }

  if (state.status === "unauthenticated") {
    return <LoginForm onSuccess={() => setState({ status: "authenticated" })} />;
  }

  return <>{children}</>;
}
